/**
 * Interaktive Vertriebsgebiete-Karte im Ansprechpartner-Bereich.
 *
 * Jede Gebietsflaeche (.js-ansprechpartnerMapArea) traegt data-region mit dem
 * Gebietswert der Ansprechpartner ("Gebiet N"). Klick / Enter / Leertaste
 * waehlt das Gebiet, ein erneuter Klick auf das aktive Gebiet setzt den Filter
 * zurueck. Die eigentliche Filterung bleibt in ansprechpartner.js: die Karte
 * meldet die Auswahl ueber onSelect und wird ueber sync() nachgezogen, wenn
 * der Gebietsfilter (Dropdown) geaendert wird.
 *
 * Vanilla JS, kein jQuery.
 */
export function initAnsprechpartnerMap(root, onSelect) {
    const map = root.querySelector('.js-ansprechpartnerMap');
    const svg = map ? map.querySelector('svg') : null;
    const areas = map ? Array.from(map.querySelectorAll('.js-ansprechpartnerMapArea')) : [];

    if (!svg || !areas.length) {
        return { sync() {} };
    }

    const valueOf = area => (area.dataset.region || '').trim().toLowerCase();
    // Aktive Flaeche ans Ende der Gebiete haengen, damit Rand und Schatten
    // nicht von Nachbarflaechen ueberdeckt werden (SVG kennt kein z-index).
    const lastArea = areas[areas.length - 1];
    const areaAnchor = lastArea.nextSibling;
    let current = '';

    function sync(value) {
        current = value || '';
        const isAreaValue = areas.some(area => valueOf(area) === current);

        areas.forEach(area => {
            const active = valueOf(area) === current;
            area.classList.toggle('is-active', active);
            area.setAttribute('aria-pressed', active ? 'true' : 'false');
            if (active) {
                svg.insertBefore(area, areaAnchor);
            }
        });

        map.querySelectorAll('[data-gebiet]:not(.js-ansprechpartnerMapArea)').forEach(label => {
            const area = areas.find(a => a.dataset.gebiet === label.dataset.gebiet);
            label.classList.toggle('is-active', !!area && valueOf(area) === current);
        });

        // has-selection: Gebiet aktiv -> uebrige Flaechen zuruecknehmen.
        // is-outside: Filter auf einen Wert ohne Kartenflaeche (z. B. Ausland,
        // Innendienst) -> Karte insgesamt dezent abblenden.
        map.classList.toggle('has-selection', isAreaValue);
        map.classList.toggle('is-outside', current !== '' && !isAreaValue);
    }

    function choose(area) {
        const value = valueOf(area);
        const next = value === current ? '' : value;
        onSelect(next, next === '' ? '' : area.dataset.region.trim());
    }

    areas.forEach(area => {
        area.addEventListener('click', () => choose(area));
        area.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                choose(area);
            }
        });
        // Hover-Kopplung fuer die Gebietsnummer (liegt ueber der Flaeche).
        area.addEventListener('pointerenter', () => map.dataset.hover = area.dataset.gebiet);
        area.addEventListener('pointerleave', () => delete map.dataset.hover);
    });

    return { sync };
}
